import { FC, useState } from "react";
import { Box, Flex } from "@otrium/core";
import { isNumber } from "lodash-es";
import { Add } from "src/icons/Add";
import { Remove } from "src/icons/Remove";
import { StyledButton } from "./CounterInput.styled";

interface Props {
  count?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange: (count: number) => void;
}

const CountInput: FC<Props> = ({
  count: defaultCount = 0,
  min = -Infinity,
  max = Infinity,
  disabled = false,
  onChange,
}) => {
  const [count, setCount] = useState<number>(defaultCount);

  const decrement = () => {
    if (isNumber(min) && count <= min) {
      return;
    }
    setCount(count - 1);
    onChange(count - 1);
  };

  const increment = () => {
    if (isNumber(max) && count >= max) {
      return;
    }
    setCount(count + 1);
    onChange(count + 1);
  };

  return (
    <Flex>
      <StyledButton
        data-testid="counter-input-decrement"
        disabled={disabled || count === min}
        onClick={decrement}
        aria-label="Decrease the number of products"
      >
        <Remove />
      </StyledButton>

      <Box
        data-testid="counter-input-count"
        height="24px"
        width="48px"
        color="tone.black"
        sx={{
          textAlign: "center",
        }}
      >
        {count}
      </Box>

      <StyledButton
        data-testid="counter-input-increment"
        disabled={disabled || count === max}
        onClick={increment}
        aria-label="Increase the number of products"
      >
        <Add />
      </StyledButton>
    </Flex>
  );
};

export default CountInput;
